/* eslint-disable no-plusplus */
const calculateSum = (cpf: string, length: number, factor: number): number => {
  let sum = 0;
  for (let i = 0; i < length; i++) {
    const digit = parseInt(cpf.charAt(i), 10); // Use charAt para extrair o dígito
    // eslint-disable-next-line no-param-reassign
    sum += digit * factor--;
  }
  return sum;
};

const calculateRemainder = (sum: number): number => {
  const remainder = (sum * 10) % 11;
  return remainder >= 10 ? 0 : remainder;
};

const isValidDigit = (
  remainder: number,
  cpf: string,
  length: number,
): boolean => {
  const expectedDigit = parseInt(cpf.charAt(length), 10); // Use charAt para extrair o dígito
  return remainder === expectedDigit;
};

const checkDigit = (cpf: string, length: number, factor: number): boolean => {
  const sum = calculateSum(cpf, length, factor);
  const remainder = calculateRemainder(sum);
  return isValidDigit(remainder, cpf, length);
};

const checkCPFChecksum = (cpf: string): boolean =>
  checkDigit(cpf, 9, 10) && checkDigit(cpf, 10, 11);

const isInvalidCPF = (cpf: string): boolean => {
  const invalidsCpf = [
    "00000000000",
    "11111111111",
    "22222222222",
    "33333333333",
    "44444444444",
    "55555555555",
    "66666666666",
    "77777777777",
    "88888888888",
    "99999999999",
  ];
  return invalidsCpf.includes(cpf) || cpf.length !== 11;
};

const validateCpf = (cpf?: string): boolean => {
  if (!cpf) return false;

  const cpfWithoutMask = cpf.replace(/[^\d]+/g, "");

  if (isInvalidCPF(cpfWithoutMask)) return false;

  return checkCPFChecksum(cpfWithoutMask);
};

export default validateCpf;
